import { Component, Input, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'app/core/base/base.component';
import { ApprovalMatrixService } from 'app/modules/approval-matrix/service/approval-matrix.service';

@Component({
  selector: 'app-matrix-preview',
  templateUrl: './matrix-preview.component.html',
  styleUrl: './matrix-preview.component.scss',
})
export class MatrixPreviewComponent extends BaseComponent {
  previewData: any[] = [];
  statusData: any = null;
  @Input() matrixId: number;
  @Input() default: boolean = false;
  @Input() scope: string = '';
  @Input() user: string = '';
  @Input() request_id: number = 0;
  loading = true;
  matrix_name: string = '';

  constructor(private axs: ApprovalMatrixService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['matrixId'] && changes['matrixId'].currentValue) {
      this.loadPreview();
    }
    if (changes['default'] && changes['default'].currentValue) {
      this.loadPreview(false);
    }
    if (changes['request_id'] && changes['request_id'].currentValue) {
      this.loadStatusPreview();
    }
  }

  loadPreview(_default = true) {
    this.loading = true;
    if (_default) {
      this.axs.getMatrixPreview(this.matrixId).subscribe((res) => {
        this.previewData = res.stages;
        this.loading = false;
        this.matrix_name = res.name;
      });
    } else {
      this.axs.getMatrixPreview(0, this.scope, this.user).subscribe((res) => {
        this.previewData = res.stages;
        this.loading = false;
        this.matrix_name = res.name;
      });
    }
  }

  loadStatusPreview() {
    this.loading = true;
    this.axs.getApprovalRequestStatus(this.request_id).subscribe((res) => {
      this.statusData = res;
      this.loading = false;
    });
  }

  getGroupClusters(groups: any[]): any[][] {
    if (!groups?.length) return [];
    const clusters: any[][] = [];
    let current: any[] = [];
    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];
      if (i === 0 || group.operator?.toUpperCase() !== 'AND') {
        if (current.length) clusters.push(current);
        current = [group];
      } else {
        current.push(group);
      }
    }
    if (current.length) clusters.push(current);
    return clusters;
  }

  getGroupApprovalSummary(group: any): string {
    return group.approval_summary;
  }

  getUserNames(users: any[]): string[] {
    return users.map((u) => u.name);
  }

  getAvatarStyle(action: string) {
    switch (action?.toUpperCase()) {
      case 'APPROVED':
        return { 'background-color': '#d4f8e8', color: '#1e7f4f' };
      case 'REJECTED':
      case 'REJECT':
        return { 'background-color': '#fde2e2', color: '#a12626' };
      default:
        return { 'background-color': '#f3f3f3', color: '#555' };
    }
  }
}
